import { Area, AreaChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import React, { FunctionComponent } from "react";

import Registration from "../../models/registration/Registration";

interface NumberOfRegistrationsChartData {
  name: string;
  Anmeldungen: number;
}

interface Props {
  registrations: Registration[];
  height?: number;
}

const ACCENT = "var(--accent)";

export const NumberOfRegistrationsChart: FunctionComponent<Props> = ({ registrations, height = 190 }: Props) => {
  const chartData = mapToChartData(registrations);

  return (
    <ResponsiveContainer width={"100%"} height={height}>
      <AreaChart data={chartData} margin={{ top: 6, right: 4, left: -22, bottom: 0 }}>
        <defs>
          <linearGradient id="registrationsArea" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor={ACCENT} stopOpacity={0.16} />
            <stop offset="100%" stopColor={ACCENT} stopOpacity={0.02} />
          </linearGradient>
        </defs>
        <CartesianGrid stroke="#f2ebe3" vertical={false} />
        <XAxis
          dataKey="name"
          stroke="#ada195"
          tickLine={false}
          axisLine={false}
          minTickGap={40}
          tick={{ fontSize: 11.5 }}
        />
        <YAxis stroke="#ada195" tickLine={false} axisLine={false} width={40} tick={{ fontSize: 11.5 }} />
        <Tooltip
          contentStyle={{
            backgroundColor: "#fff",
            border: "1px solid var(--border)",
            borderRadius: "var(--radius-md)",
            boxShadow: "var(--shadow-md)",
            fontSize: 13
          }}
        />
        <Area
          type="monotone"
          dataKey="Anmeldungen"
          stroke={ACCENT}
          fill="url(#registrationsArea)"
          strokeWidth={1.8}
          activeDot={{ r: 3 }}
        />
      </AreaChart>
    </ResponsiveContainer>
  );
};

function mapToChartData(registrations: Registration[]): NumberOfRegistrationsChartData[] {
  const sortedRegistrations = [...registrations].sort(
    (a, b) => a.creation.createdAt.getTime() - b.creation.createdAt.getTime()
  );

  if (sortedRegistrations.length === 0) {
    return [];
  }

  const dates = getDatesInRange(sortedRegistrations[0].creation.createdAt, new Date());

  let currentNumberOfRegistrations = 0;
  return dates.map((date) => {
    const registrationsPerDate = registrations.filter(
      (value) => new Date(value.creation.createdAt).setHours(0, 0, 0, 0) === new Date(date).setHours(0, 0, 0, 0)
    );
    currentNumberOfRegistrations += registrationsPerDate.length;
    return {
      name: date.toLocaleDateString("de-CH", { day: "numeric", month: "numeric" }),
      Anmeldungen: currentNumberOfRegistrations
    };
  });
}

function getDatesInRange(start: Date, end: Date): Date[] {
  const dates: Date[] = [];
  for (let dt = new Date(start); dt <= end; dt.setDate(dt.getDate() + 1)) {
    dates.push(new Date(dt));
  }
  return dates;
}
